<template>
  <tg-layout :headerHeight="100" ref="layout">
    <template slot="header">
      <tg-amount-bar
        ref="amount"
        :columns="amountColumns"
        :row="amountData"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      :cell-class-name="parseCellClass"
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name-with-link
          :row="scope.row"
          :column="scope.column"
          :token="queryToken"
          route="accounts.paper.user"
        ></tg-user-full-name-with-link>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
// import TgUserFullName from "@/components/slot/TgUserFullName";
import TgUserFullNameWithLink from "@/components/slot/TgUserFullNameWithLink";
import TgAmountBar from "@/components/amount/TgAmountBar";

import str from "@/utils/str";
import apis from "@/apis";
const api = apis.accounts.paper.bet;

export default {
  components: {
    TgLayout,
    TgTable,
    // TgUserFullName,
    TgUserFullNameWithLink,
    TgAmountBar,
  },
  data() {
    return {
      columns: [],
      amountColumns: [],
      amountData: {},
      proxy: api.getData,
      showAmount: false,
    };
  },
  props: {
    username: {
      type: String,
      required: true,
    },
    check: Boolean
  },
  created() {
    if (!this.username) {
      this.$router.push({ name: "accounts.paper" });
      return;
    }
    let title = str.format(
      "{0} ({1})",
      this.$t("column.num_of_bet_people"),
      this.username
    );

    if (this.request.betOption) {
      title = this.$t("enum.betOptions[" + this.request.betOption + "]") + "-" + title;
    }

    this.$store.commit("breadcrumb/add", {
      name: "accounts.paper.bet",
      query: {
        ...this.$route.query,
      },
      path: this.$route.path,
      meta: {
        title: title,
      },
    });
    api.getColumns().then((response) => {
      this.columns = response.data;
      this.amountColumns = response.data.slice(2);
      this.$refs.table.init(this.request);
    });
  },
  computed: {
    headerHeight() {
      return this.showAmount ? 120 : 0;
    },
    queryToken() {
      return this.$route.query.token;
    },
    request() {
      let query = JSON.parse(str.decrypt(this.$route.query.token));
      return {
        ...query,
        targetName: this.username
      }
    }
  },
  methods: {
    parseCellClass({ column }) {
      if (column.columnKey == "name") {
        return "clickable text-primary";
      }
    },
    handleLoaded(response) {
      if (response.retcode == 0) {
        this.showAmount = !("length" in response.total);
        this.amountData = response.total;
      }
    },
  },
  watch: {
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
